module.exports = __webpack_public_path__ + "static/media/sidebar-rooms-venue.b0879fd6.svg";